module.exports = __webpack_public_path__ + "img/ecosystem_o1_main.a37d8d70.png";